// Per-site SEO copy for tour pages, as Mustache templates rendered by
// useSiteSeo with the page's view. Keyed by the host the page is served as
// (an alias's own host when one is in play), then by route path: an exact
// path, or a prefix ending in "*". A page with no entry here uses the title
// and description it passes to useSiteSeo. An entry may also carry an `h1`,
// plain text (not a template) shown as the page's visible heading, and an
// `intro`, a plain-text paragraph shown under it; read them with sitePageH1
// and sitePageIntro. The /models entries' intros say `{count}` where the page
// puts its model count, and add an `outro`, the paragraph under the grid,
// whose links are written as `[label](target)`; see linkedCopySegments.
//
// This copy used to live in backstage (sites.seo_site_page_settings) and was
// moved here verbatim so the column could be dropped. Edit it here.
export const SITE_PAGE_SEO = {
  "anal4k.com": {
    "/top-rated": {
      title: "Top Rated Anal4K Videos – Best Anal Scenes in HD 4K",
      description:
        "The highest-rated anal scenes on Anal4K, ranked by member score. Browse the best Anal4K videos in HD 4K, updated as new ratings come in.",
      h1: "Top Rated Anal4K Videos",
    },
    "/": {
      title:
        "Anal4K Official Site – Hardcore Anal Porn Videos in HD 4K{{#showPageNumber}} | Page: {{ pageNumber }}{{/showPageNumber}}",
      description:
        "Anal4K films hardcore anal sex scenes in true HD 4K. Gorgeous models, close-up detail, new anal videos every week. Watch the latest Anal4K scenes now.{{#showPageNumber}} | Page: {{ pageNumber }}{{/showPageNumber}}",
      h1: "Anal4K - Hardcore Anal Porn Videos Filmed in HD 4K",
      intro:
        "Anal4K delivers hardcore anal porn videos shot in true 4K Ultra HD, filmed full length with multiple angles and studio lighting. Membership unlocks the full Anal4K library, new releases added regularly, and unlimited streaming and downloads. Join Anal4K now for the highest quality anal porn on the web.",
    },
    "/login": {
      title: "{{ siteName }} Login Page to Our Member's Area",
      description:
        " Login to {{ siteName }} here to gain access to our Member's Area.",
    },
    "/models": {
      title: "Anal4K Models – All Anal Pornstars Filmed in Ultra HD 4K",
      description:
        "Browse every Anal4K model: anal pornstars filmed in Ultra HD 4K. See each model's scenes, ranked by member rating.",
      h1: "Anal4K Models - Anal Pornstars in Ultra HD 4K",
      intro:
        "{count} models and counting, every one filmed in Ultra HD 4K with free scene previews on each profile.",
      outro:
        "Anal4K features the girls who love anal and the camera quality to prove it. Every model on this list has at least one scene filmed in Ultra HD 4K, with close-up detail you will not find on tube sites. Click any model to see her profile, all of her Anal4K scenes, and a free preview of each one. The list is ranked by member rating, so the top anal performers sit at the top. Browse by [first anal], [gape], [creampie], or [petite], or jump to the [newest videos](/) to see the latest additions.",
    },
    "/series": {
      title: "{{ siteName }} - Check out all of our Series",
      description: "Browse all of our {{ siteName }} Series.",
    },
    "/series/*": {
      title: "Watch {{ sponsorName }} videos on {{ siteName }}!",
      description:
        "Browse all of our full length {{ sponsorName }} videos on {{ siteName }} in 4K HD.",
    },
  },
  "baeb.com": {
    "/": {
      title:
        "{{ siteName }} Official Site – 4K HD Glamour Porn{{#showPageNumber}} | Page: {{ pageNumber }}{{/showPageNumber}}",
      description:
        "{{ siteName }} offers young sexy girls featured in hardcore porn movies that are shot in 4K ultra HD.{{#showPageNumber}} | Page: {{ pageNumber }}{{/showPageNumber}}",
    },
    "/login": {
      title: "{{ siteName }} Login Page to Our Member's Area",
      description:
        " Login to {{ siteName }} here to gain access to our Member's Area.",
    },
    "/models": {
      title: "Check out all of our models on {{ siteName }}!",
      description:
        "Find your favorite {{ siteName }} models from the official site in 4K HD. Organized and sorted however you like it!",
    },
    "/series": {
      title: "{{ siteName }} - Check out all of our Series",
      description: "Browse all of our {{ siteName }} Series.",
    },
    "/series/*": {
      title: "Watch {{sponsorName}} videos on {{ siteName }}!",
      description:
        "Browse all of our full length {{sponsorName}} videos on {{ siteName }} in 4K HD.",
    },
  },
  "bathhousebait.com": {
    "/": {
      title:
        "{{ siteName }} Official Site – Gay Bath House HD Videos{{#showPageNumber}} | Page: {{ pageNumber }}{{/showPageNumber}}",
      description:
        "See guys uncensored in the bath house!  Full Length Scenes Available for Download.  Updated regularly.{{#showPageNumber}} | Page: {{ pageNumber }}{{/showPageNumber}}",
    },
    "/models": {
      title:
        "{{ siteName }} : Gay Porn Models Featured on {{ siteName }}{{#showLetter}} | By Letter: {{ letter }}{{/showLetter}} {{#showPageNumber}} | Page: {{ pageNumber }}{{/showPageNumber}}",
      description:
        "Watch exclusive {{ siteName }} gay movies in HD!{{#showLetter}} | By Letter: {{ letter }}{{/showLetter}} {{#showPageNumber}} | Page: {{ pageNumber }}{{/showPageNumber}}",
    },
  },
  "bbcpie.com": {
    "/top-rated": {
      title:
        "Top Rated BBC Pie Videos – Best Interracial Creampie Scenes in 4K",
      description:
        "The highest-rated interracial creampie scenes on BBC Pie, ranked by member score. Browse the best BBC Pie videos in 4K, updated as new ratings come in.",
      h1: "Top Rated BBC Pie Videos",
    },
    "/": {
      title:
        "BBC Pie Official Site – Interracial Creampie Porn in 4K{{#showPageNumber}} | Page: {{ pageNumber }}{{/showPageNumber}}",
      description:
        "BBC Pie: interracial sex scenes that end in real creampies, filmed in 4K. New BBC creampie videos every week. Watch the latest BBC Pie releases.{{#showPageNumber}} | Page: {{ pageNumber }}{{/showPageNumber}}",
      h1: "BBC Pie - Interracial Creampie Porn Videos in 4K",
      intro:
        "BBC Pie is the premier site for interracial creampie porn videos in 4K Ultra HD, with gorgeous adult models and real chemistry in every full-length scene. Members stream and download the entire archive in 4K, get new scenes added regularly. Join BBC Pie today for the best interracial porn online.",
    },
    "/login": {
      title: "{{ siteName }} Login Page to Our Member's Area",
      description:
        " Login to {{ siteName }} here to gain access to our Member's Area.",
    },
    "/models": {
      title: "BBC Pie Models – All Interracial Creampie Pornstars in 4K",
      description:
        "Browse every BBC Pie model: interracial creampie pornstars filmed in 4K. See each model's scenes, ranked by member rating.",
      h1: "BBC Pie Models - Interracial Creampie Pornstars in 4K",
      intro:
        "{count} models and counting, every one filmed in 4K with free scene previews on each profile.",
      outro:
        "BBC Pie is the home of interracial creampie scenes, filmed in 4K. The models here range from newcomers to established pornstars, and every one of them finishes with a creampie on camera. Open any profile to see all of her BBC Pie scenes and a free preview of each. Models are ranked by member rating, so the fan favorites are always at the top. Browse by [creampie], [interracial], [teen], or [MILF], or see the [newest videos](/) to find out who just joined.",
    },
    "/series": {
      title: "{{ siteName }} - Check out all of our Series",
      description: "Browse all of our {{ siteName }} Series.",
    },
    "/series/*": {
      title: "Watch {{sponsorName}} videos on {{ siteName }}!",
      description:
        "Browse all of our full length {{sponsorName}} videos on {{ siteName }} in 4K HD.",
    },
  },
  "boysdestroyed.com": {
    "/": {
      title:
        "{{ siteName }} Official Site – Interracial Gay Porn in HD{{#showPageNumber}} | Page: {{ pageNumber }}{{/showPageNumber}}",
      description:
        "See 4k HD interracial gay porn videos!  Full Length Scenes Available for Download.  Updated regularly.{{#showPageNumber}} | Page: {{ pageNumber }}{{/showPageNumber}}",
    },
    "/models": {
      title:
        "{{ siteName }} : Gay Porn Models Featured on {{ siteName }}{{#showLetter}} | By Letter: {{ letter }}{{/showLetter}} {{#showPageNumber}} | Page: {{ pageNumber }}{{/showPageNumber}}",
      description:
        "Watch exclusive {{ siteName }} gay movies in HD!{{#showLetter}} | By Letter: {{ letter }}{{/showLetter}} {{#showPageNumber}} | Page: {{ pageNumber }}{{/showPageNumber}}",
    },
  },
  "castingcouch-x.com": {
    "/top-rated": {
      title:
        "Top Rated Casting Couch X Videos – Best Amateur Casting Scenes in HD",
      description:
        "The highest-rated amateur casting scenes on Casting Couch X, ranked by member score. Browse the best Casting Couch X videos in HD, updated as new ratings come in.",
      h1: "Top Rated Casting Couch X Videos",
    },
    "/": {
      title:
        "Casting Couch X Official Site – Amateur Casting Porn in HD{{#showPageNumber}} | Page: {{ pageNumber }}{{/showPageNumber}}",
      description:
        "Casting Couch X: real first-time amateurs audition on the casting couch in full HD. New casting videos every week. Watch the newest auditions now.{{#showPageNumber}} | Page: {{ pageNumber }}{{/showPageNumber}}",
      h1: "Casting Couch X - Amateur Casting Audition Porn Videos in HD",
      intro:
        "Casting Couch X captures amateur casting audition porn in HD, with new faces, candid interviews and auditions that turn into hardcore sex, all starring new girls entering the porn industry. New auditions added regularly, and unlimited streaming. Join Casting Couch X and watch every audition uncut.",
    },
    "/login": {
      title: "{{ siteName }} Login Page to Our Member's Area",
      description:
        " Login to {{ siteName }} here to gain access to our Member's Area.",
    },
    "/models": {
      title:
        "Casting Couch X Models – Every Amateur Girl Who Auditioned, in HD",
      description:
        "Browse every Casting Couch X model: amateur girls in their first casting audition, filmed in HD. See each model's scenes, ranked by member rating.",
      h1: "Casting Couch X Models - Amateur Girls Who Auditioned on Camera",
      intro:
        "{count} models and counting, every one filmed in HD with free scene previews on each profile.",
      outro:
        "Casting Couch X is where amateur girls audition on camera for the first time. Every model on this list showed up for a real casting, so what you see is her first scene, nerves and all. Open any profile to watch a free preview of her audition and see whether she came back for more. Models are ranked by member rating, so the auditions members loved most are always first. Browse by [amateur], [first time], [casting], or [teen], or check the [newest videos](/) to meet the latest girls to sit on the couch.",
    },
    "/series": {
      title: "{{ siteName }} - Check out all of our Series",
      description: "Browse all of our {{ siteName }} Series.",
    },
    "/series/*": {
      title: "Watch {{sponsorName}} videos on {{ siteName }}!",
      description:
        "Browse all of our full length {{sponsorName}} videos on {{ siteName }} in 4K HD.",
    },
  },
  "creepypa.com": {
    "/": {
      title:
        "{{ siteName }} Official Site – Ultra High Def Porn{{#showPageNumber}} | Page: {{ pageNumber }}{{/showPageNumber}}",
      description:
        "{{ siteName }} Ultra High Def Porn {{#showPageNumber}} | Page: {{ pageNumber }}{{/showPageNumber}}",
    },
  },
  "cum4k.com": {
    "/top-rated": {
      title: "Top Rated Cum4K Videos – Best Creampie Scenes in Ultra HD 4K",
      description:
        "The highest-rated creampie scenes on Cum4K, ranked by member score. Browse the best Cum4K videos in Ultra HD 4K, updated as new ratings come in.",
      h1: "Top Rated Cum4K Videos",
    },
    "/": {
      title:
        "Cum4K Official Site – Creampie Porn Videos in 4K HD{{#showPageNumber}} | Page: {{ pageNumber }}{{/showPageNumber}}",
      description:
        "Cum4K films creampie sex scenes with real, multiple finishes in Ultra HD 4K. New creampie videos every week. Watch the latest Cum4K scenes now.{{#showPageNumber}} | Page: {{ pageNumber }}{{/showPageNumber}}",
      h1: "Cum4K - Creampie Porn Videos with Real Finishes in Ultra HD 4K",
      intro:
        "Cum4K is the go-to site for creampie porn videos, filmed full length in crystal-clear Ultra HD 4K. Members unlock the complete library, new creampie scenes added regularly, and unlimited 4K streaming and downloads. Join Cum4K today and see every finish in true 4K.",
    },
    "/login": {
      title: "{{ siteName }} Login Page to Our Member's Area",
      description:
        " Login to {{ siteName }} here to gain access to our Member's Area.",
    },
    "/models": {
      title: "Cum4K Models – All Creampie Pornstars Filmed in Ultra HD 4K",
      description:
        "Browse every Cum4K model: creampie pornstars filmed in Ultra HD 4K. See each model's scenes, ranked by member rating.",
      h1: "Cum4K Models - Creampie Pornstars in Ultra HD 4K",
      intro:
        "{count} models and counting, every one filmed in Ultra HD 4K with free scene previews on each profile.",
      outro:
        "Cum4K is all about the creampie, filmed in Ultra HD 4K so you see every detail of the finish. Every model on this list has at least one Cum4K scene, and many have several. Open any profile for her full scene list and a free preview of each one. Models are ranked by member rating, so the performers members keep coming back for are always at the top. Browse by [creampie], [multiple creampies], [teen], or [MILF], or see the [newest videos](/) to find out who was just added.",
    },
    "/series": {
      title: "{{ siteName }} - Check out all of our Series",
      description: "Browse all of our {{ siteName }} Series.",
    },
    "/series/*": {
      title: "Watch {{sponsorName}} videos on {{ siteName }}!",
      description:
        "Browse all of our full length {{sponsorName}} videos on {{ siteName }} in 4K HD.",
    },
  },
  "damnthatsbig.com": {
    "/": {
      title:
        "{{ siteName }} Official Site – Monster Gay Cock Videos{{#showPageNumber}} | Page: {{ pageNumber }}{{/showPageNumber}}",
      description:
        "See 4k HD monster gay cock porn videos!  Full Length Scenes Available for Download.  Updated regularly.{{#showPageNumber}} | Page: {{ pageNumber }}{{/showPageNumber}}",
    },
    "/models": {
      title:
        "{{ siteName }} : Gay Porn Models Featured on {{ siteName }}{{#showLetter}} | By Letter: {{ letter }}{{/showLetter}} {{#showPageNumber}} | Page: {{ pageNumber }}{{/showPageNumber}}",
      description:
        "Watch exclusive {{ siteName }} gay movies in HD!{{#showLetter}} | By Letter: {{ letter }}{{/showLetter}} {{#showPageNumber}} | Page: {{ pageNumber }}{{/showPageNumber}}",
    },
  },
  "exgfpass.com": {
    "/": {
      title:
        "{{ siteName }} Official Site – Amateur and Ex Girlfriend Porn{{#showPageNumber}} | Page: {{ pageNumber }}{{/showPageNumber}}",
      description:
        "Ex Girlfriend site with thousands of Amateur Porn Photos and Videos!{{#showPageNumber}} | Page: {{ pageNumber }}{{/showPageNumber}}",
    },
    "/models": {
      title: "Sort by Model - {{ siteName }}",
      description: "Find your favorite Girls on EXGF Pass",
    },
  },
  "exotic4k.com": {
    "/top-rated": {
      title:
        "Top Rated Exotic4K Videos – Best Exotic Model Scenes in Ultra HD 4K",
      description:
        "The highest-rated exotic model scenes on Exotic4K, ranked by member score. Browse the best Exotic4K videos in Ultra HD 4K, updated as new ratings come in.",
      h1: "Top Rated Exotic4K Videos",
    },
    "/": {
      title:
        "Exotic4K Official Site – Exotic Hardcore Porn in Ultra HD 4K{{#showPageNumber}} | Page: {{ pageNumber }}{{/showPageNumber}}",
      description:
        "Exotic4K: Latina, Asian, Black and mixed models in hardcore sex scenes filmed in Ultra HD 4K. New exotic videos every week. Watch the latest scenes.{{#showPageNumber}} | Page: {{ pageNumber }}{{/showPageNumber}}",
      h1: "Exotic4K - Exotic Models in Hardcore Porn Videos, Ultra HD 4K",
      intro:
        "Exotic4K features Latina, Asian, Ebony and mixed-heritage adult models in hardcore porn videos filmed in Ultra HD 4K. Membership gives you the full archive, new releases added regularly, and unlimited 4K streaming and downloads. Join Exotic4K today for stunning, diverse performers in sharp 4K.",
    },
    "/login": {
      title: "{{ siteName }} Login Page to Our Member's Area",
      description:
        " Login to {{ siteName }} here to gain access to our Member's Area.",
    },
    "/models": {
      title: "Exotic4K Models – All Exotic Pornstars Filmed in Ultra HD 4K",
      description:
        "Browse every Exotic4K model: Black, Latina, Asian and Middle Eastern pornstars filmed in Ultra HD 4K. See each model's scenes, ranked by member rating.",
      h1: "Exotic4K Models - Black, Latina, Asian and Middle Eastern Pornstars",
      intro:
        "{count} models and counting, every one filmed in Ultra HD 4K with free scene previews on each profile.",
      outro:
        "Exotic4K is where you find the most beautiful women from around the world, filmed in Ultra HD 4K. Our models include [Black], [Latina], [Asian], Indian and Middle Eastern performers, from first-timers to established pornstars. Click any model to see her full profile, every scene she has filmed for Exotic4K, and a free preview of each one. Models are ranked by member rating, so the most popular girls are always at the top. Looking for something specific? Browse by [creampie], [facial], [blowjob] or [anal], or see the [newest videos](/) to find out who just joined.",
    },
    "/series": {
      title: "{{ siteName }} - Check out all of our Series",
      description: "Browse all of our {{ siteName }} Series.",
    },
    "/series/*": {
      title: "Watch {{sponsorName}} videos on {{ siteName }}!",
      description:
        "Browse all of our full length {{sponsorName}} videos on {{ siteName }} in 4K HD.",
    },
  },
  "facials4k.com": {
    "/top-rated": {
      title:
        "Top Rated Facials4K Videos – Best Facial Cumshot Scenes in Ultra HD 4K",
      description:
        "The highest-rated facial cumshot scenes on Facials4K, ranked by member score. Browse the best Facials4K videos in Ultra HD 4K, updated as new ratings come in.",
      h1: "Top Rated Facials4K Videos",
    },
    "/": {
      title:
        "Facials4K Official Site – Facial Cumshot Porn in Ultra HD 4K{{#showPageNumber}} | Page: {{ pageNumber }}{{/showPageNumber}}",
      description:
        "Facials4K: hardcore scenes that end with huge facial cumshots, filmed in Ultra HD 4K. New facial videos every week. Watch the latest Facials4K scenes.{{#showPageNumber}} | Page: {{ pageNumber }}{{/showPageNumber}}",
      h1: "Facials4K - Facial Cumshot Porn Videos in Ultra HD 4K",
      intro:
        "Facials4K is dedicated to facial cumshot porn videos in Ultra HD 4K, with every big finish captured in close-up detail. Members get the complete library, new scenes added regularly, and unlimited streaming and downloads. Join Facials4K now for facial porn the way it should look.",
    },
    "/login": {
      title: "{{ siteName }} Login Page to Our Member's Area",
      description:
        " Login to {{ siteName }} here to gain access to our Member's Area.",
    },
    "/models": {
      title: "Facials4K Models – All Facial Cumshot Pornstars in Ultra HD 4K",
      description:
        "Browse every Facials4K model: facial cumshot pornstars filmed in Ultra HD 4K. See each model's scenes, ranked by member rating.",
      h1: "Facials4K Models - Facial Cumshot Pornstars in Ultra HD 4K",
      intro:
        "{count} models and counting, every one filmed in Ultra HD 4K with free scene previews on each profile.",
      outro:
        "Facials4K is built for one thing: the facial cumshot, filmed in Ultra HD 4K so nothing is missed. Every model on this list has at least one Facials4K scene that ends the way the name promises. Open any profile to see all of her scenes and a free preview of each one. Models are ranked by member rating, so the performers members rate highest are always first. Browse by [facial], [blowjob], [deepthroat], or [teen], or see the [newest videos](/) to find out who just joined.",
    },
    "/series": {
      title: "{{ siteName }} - Check out all of our Series",
      description: "Browse all of our {{ siteName }} Series.",
    },
    "/series/*": {
      title: "Watch {{sponsorName}} videos on {{ siteName }}!",
      description:
        "Browse all of our full length {{sponsorName}} videos on {{ siteName }} in 4K HD.",
    },
  },
  "fantasyhd.com": {
    "/": {
      title:
        "{{ siteName }} Official Site – 4K HD Fantasy Porn{{#showPageNumber}} | Page: {{ pageNumber }}{{/showPageNumber}}",
      description:
        "Experience your erotic fantasies with the hottest pornstars in Full HD High Definition 1080p porn videos. Updated Daily.{{#showPageNumber}} | Page: {{ pageNumber }}{{/showPageNumber}}",
    },
    "/login": {
      title: "{{ siteName }} Login Page to Our Member's Area",
      description:
        " Login to {{ siteName }} here to gain access to our Member's Area.",
    },
    "/models": {
      title: "Check out all of our models on {{ siteName }}!",
      description:
        "Find your favorite {{ siteName }} models from the official site in 4K HD. Organized and sorted however you like it!",
    },
    "/series": {
      title: "{{ siteName }} - Check out all of our Series",
      description: "Browse all of our {{ siteName }} Series.",
    },
    "/series/*": {
      title: "Watch {{sponsorName}} videos on {{ siteName }}!",
      description:
        "Browse all of our full length {{sponsorName}} videos on {{ siteName }} in 4K HD.",
    },
  },
  "gaycastings.com": {
    "/": {
      title:
        "{{ siteName }} Official Site – Gay Casting Couch Videos{{#showPageNumber}} | Page: {{ pageNumber }}{{/showPageNumber}}",
      description:
        "See 4k HD gay casting couch audition videos!  Full Length Scenes Available for Download.  Updated regularly.{{#showPageNumber}} | Page: {{ pageNumber }}{{/showPageNumber}}",
    },
    "/models": {
      title:
        "{{ siteName }} : Gay Porn Models Featured on {{ siteName }}{{#showLetter}} | By Letter: {{ letter }}{{/showLetter}} {{#showPageNumber}} | Page: {{ pageNumber }}{{/showPageNumber}}",
      description:
        "Watch exclusive {{ siteName }} gay movies in HD!{{#showLetter}} | By Letter: {{ letter }}{{/showLetter}} {{#showPageNumber}} | Page: {{ pageNumber }}{{/showPageNumber}}",
    },
  },
  "gaycreeps.com": {
    "/": {
      title:
        "{{ siteName }} Official Site – Gay Creep Videos{{#showPageNumber}} | Page: {{ pageNumber }}{{/showPageNumber}}",
      description:
        "See guys have sex with their straight roommates!  Full Length Scenes Available for Download.  Updated regularly.{{#showPageNumber}} | Page: {{ pageNumber }}{{/showPageNumber}}",
    },
    "/models": {
      title:
        "{{ siteName }} : Gay Porn Models Featured on {{ siteName }}{{#showLetter}} | By Letter: {{ letter }}{{/showLetter}} {{#showPageNumber}} | Page: {{ pageNumber }}{{/showPageNumber}}",
      description:
        "Watch exclusive {{ siteName }} gay movies in HD!{{#showLetter}} | By Letter: {{ letter }}{{/showLetter}} {{#showPageNumber}} | Page: {{ pageNumber }}{{/showPageNumber}}",
    },
  },
  "gayroom.com": {
    "/": {
      title:
        "{{ siteName }} Official Site – 4K HD Gay Porn{{#showPageNumber}} | Page: {{ pageNumber }}{{/showPageNumber}}",
      description:
        "The best HD gay porn videos updated with the hottest men and gay sex scenes. Gay Room is the leader in exclusive hardcore gay porn movies.{{#showPageNumber}} | Page: {{ pageNumber }}{{/showPageNumber}}",
    },
    "/models": {
      title:
        "{{ siteName }} : Hot Gay Pornstars Featured on Gay Room{{#showLetter}} | By Letter: {{ letter }}{{/showLetter}} {{#showPageNumber}} | Page: {{ pageNumber }}{{/showPageNumber}}",
      description:
        "List of all hot hardcore Gay Pornstars featured Gay Room. Watch exclusive gay movies in HD!{{#showLetter}} | By Letter: {{ letter }}{{/showLetter}} {{#showPageNumber}} | Page: {{ pageNumber }}{{/showPageNumber}}",
    },
    "/sites": {
      title:
        "{{ siteName }}: Check out all of our HD Gay Porn Sites {{#showPageNumber}} | Page: {{ pageNumber }}{{/showPageNumber}}",
      description:
        "Check out all of our sites included with {{{ siteName }}} {{#showPageNumber}} | Page: {{ pageNumber }}{{/showPageNumber}}",
    },
    "/sites/*": {
      title:
        "{{ sponsorName }} Videos. {{{ sponsorName }}} is created by {{ siteName }}! {{#showPageNumber}} | Page: {{ pageNumber }}{{/showPageNumber}}",
      description:
        "Download all the {{{ sponsorName }}} videos in HD directly from GayRoom.com. We have the best quality available videos available, including in HD 1080p! {{{ sponsorName }}} is part of the GayRoom network of sites. You can ony get that quality from us!",
    },
  },
  "gayviolations.com": {
    "/": {
      title:
        "{{ siteName }} Official Site – Gay Public Porn Videos{{#showPageNumber}} | Page: {{ pageNumber }}{{/showPageNumber}}",
      description:
        "See gay public porn and sex prank videos!  Full Length Scenes Available for Download.  Updated regularly.{{#showPageNumber}} | Page: {{ pageNumber }}{{/showPageNumber}}",
    },
    "/models": {
      title:
        "{{ siteName }} : Gay Porn Models Featured on {{ siteName }}{{#showLetter}} | By Letter: {{ letter }}{{/showLetter}} {{#showPageNumber}} | Page: {{ pageNumber }}{{/showPageNumber}}",
      description:
        "Watch exclusive {{ siteName }} gay movies in HD!{{#showLetter}} | By Letter: {{ letter }}{{/showLetter}} {{#showPageNumber}} | Page: {{ pageNumber }}{{/showPageNumber}}",
    },
  },
  "girlcum.com": {
    "/top-rated": {
      title: "Top Rated GirlCum Videos – Best Female Orgasm Scenes in 4K",
      description:
        "The highest-rated female orgasm scenes on GirlCum, ranked by member score. Browse the best GirlCum videos in 4K, updated as new ratings come in.",
      h1: "Top Rated GirlCum Videos",
    },
    "/": {
      title:
        "GirlCum Official Site – Real Female Orgasm Porn in 4K{{#showPageNumber}} | Page: {{ pageNumber }}{{/showPageNumber}}",
      description:
        "GirlCum captures real, repeated female orgasms in hardcore scenes filmed in 4K. Squirting, shaking, multiple climaxes. Watch the latest GirlCum videos.{{#showPageNumber}} | Page: {{ pageNumber }}{{/showPageNumber}}",
      h1: "GirlCum - Real Female Orgasm Porn Videos in 4K",
      intro:
        "GirlCum is all about real female orgasm porn videos in 4K, where the pleasure is genuine and never faked. Members stream and download the full archive, get new scenes added regularly. Join GirlCum and see real female orgasms up close.",
    },
    "/login": {
      title: "{{ siteName }} Login Page to Our Member's Area",
      description:
        " Login to {{ siteName }} here to gain access to our Member's Area.",
    },
    "/models": {
      title: "GirlCum Models – Pornstars With Real Female Orgasms in 4K",
      description:
        "Browse every GirlCum model: pornstars with real female orgasms filmed in 4K. See each model's scenes, ranked by member rating.",
      h1: "GirlCum Models - Pornstars With Real Female Orgasms",
      intro:
        "{count} models and counting, every one filmed in 4K with free scene previews on each profile.",
      outro:
        "GirlCum is about her finish, not his. Every model on this list was filmed having real orgasms on camera, often more than one per scene, in 4K. Open any profile to see all of her GirlCum scenes and a free preview of each. Models are ranked by member rating, so the girls members respond to most are always at the top. Browse by [female orgasm](orgasm), [multiple orgasms], [squirting], or [creampie], or check the [newest videos](/) to see who was just added.",
    },
    "/series": {
      title: "{{ siteName }} - Check out all of our Series",
      description: "Browse all of our {{ siteName }} Series.",
    },
    "/series/*": {
      title: "Watch {{sponsorName}} videos on {{ siteName }}!",
      description:
        "Browse all of our full length {{sponsorName}} videos on {{ siteName }} in 4K HD.",
    },
  },
  "holed.com": {
    "/top-rated": {
      title: "Top Rated Holed Videos – Best Anal Scenes in Full HD and 4K",
      description:
        "The highest-rated anal scenes on Holed, ranked by member score. Browse the best Holed videos in Full HD and 4K, updated as new ratings come in.",
      h1: "Top Rated Holed Videos",
    },
    "/": {
      title:
        "Holed Official Site – Hardcore Anal Porn in Full HD and 4K{{#showPageNumber}} | Page: {{ pageNumber }}{{/showPageNumber}}",
      description:
        "Holed: hardcore anal sex scenes with beautiful models, filmed in Full HD and 4K. New anal videos every week. Watch the latest Holed releases now.{{#showPageNumber}} | Page: {{ pageNumber }}{{/showPageNumber}}",
      h1: "Holed - Hardcore Anal Porn Videos in Full HD and 4K",
      intro:
        "Holed is the destination for hardcore anal porn videos in Full HD and 4K, featuring top adult stars and rising new talent in full-length scenes. Membership unlocks the complete archive, new scenes added regularly, and unlimited streaming and downloads with no ads. Join Holed today for premium anal porn in HD and 4K.",
    },
    "/login": {
      title: "{{ siteName }} Login Page to Our Member's Area",
      description:
        " Login to {{ siteName }} here to gain access to our Member's Area.",
    },
    "/models": {
      title: "Holed Models – All Anal Pornstars in Full HD and 4K",
      description:
        "Browse every Holed model: anal pornstars filmed in Full HD and 4K. See each model's scenes, ranked by member rating.",
      h1: "Holed Models - Anal Pornstars in Full HD and 4K",
      intro:
        "{count} models and counting, every one filmed in Full HD and 4K with free scene previews on each profile.",
      outro:
        "Holed is anal porn with the lights on. Every model here has at least one Holed scene, filmed in Full HD or 4K with the close-up detail that made the site famous. Open any profile to see her full list of Holed scenes and a free preview of each one. Models are ranked by member rating, so the top anal performers are always first. Browse by [anal], [first anal], [gape], or [creampie], or see the [newest videos](/) to find out who just joined.",
    },
    "/series": {
      title: "{{ siteName }} - Check out all of our Series",
      description: "Browse all of our {{ siteName }} Series.",
    },
    "/series/*": {
      title: "Watch {{sponsorName}} videos on {{ siteName }}!",
      description:
        "Browse all of our full length {{sponsorName}} videos on {{ siteName }} in 4K HD.",
    },
  },
  "lubed.com": {
    "/top-rated": {
      title: "Top Rated Lubed Videos – Best Oiled-Up Scenes in Full HD and 4K",
      description:
        "The highest-rated oiled-up scenes on Lubed, ranked by member score. Browse the best Lubed videos in Full HD and 4K, updated as new ratings come in.",
      h1: "Top Rated Lubed Videos",
    },
    "/": {
      title:
        "Lubed Official Site – Oiled Up Hardcore Porn in HD and 4K{{#showPageNumber}} | Page: {{ pageNumber }}{{/showPageNumber}}",
      description:
        "Lubed: slippery, oiled-up hardcore sex scenes filmed in Full HD and 4K. Wet bodies, close-up detail, new videos every week. Watch the latest Lubed scenes.{{#showPageNumber}} | Page: {{ pageNumber }}{{/showPageNumber}}",
      h1: "Lubed - Oiled Up Hardcore Porn Videos in Full HD and 4K",
      intro:
        "Lubed delivers oiled-up hardcore porn videos in Full HD and 4K, with glistening bodies and gorgeous adult models in every full-length scene. Members get the entire library, new scenes added regularly, and unlimited streaming and downloads. If wet and wild is your thing, join Lubed and start watching now.",
    },
    "/login": {
      title: "{{ siteName }} Login Page to Our Member's Area",
      description:
        " Login to {{ siteName }} here to gain access to our Member's Area.",
    },
    "/models": {
      title: "Lubed Models – All Oiled Up Pornstars in Full HD and 4K",
      description:
        "Browse every Lubed model: oiled up pornstars filmed in Full HD and 4K. See each model's scenes, ranked by member rating.",
      h1: "Lubed Models - Oiled Up Pornstars in Full HD and 4K",
      intro:
        "{count} models and counting, every one filmed in Full HD and 4K with free scene previews on each profile.",
      outro:
        "Lubed is oil, skin and 4K cameras. Every model on this list has been covered head to toe and filmed in Full HD or 4K, in scenes that start slow and get slippery. Open any profile to see all of her Lubed scenes and a free preview of each. Models are ranked by member rating, so the performers members love most are always at the top. Browse by [oil], [massage], [big ass], or [creampie], or check the [newest videos](/) to see who was just added.",
    },
    "/series": {
      title: "{{ siteName }} - Check out all of our Series",
      description: "Browse all of our {{ siteName }} Series.",
    },
    "/series/*": {
      title: "Watch {{sponsorName}} videos on {{ siteName }}!",
      description:
        "Browse all of our full length {{sponsorName}} videos on {{ siteName }} in 4K HD.",
    },
  },
  "manroyale.com": {
    "/": {
      title:
        "{{ siteName }} Official Site – HD Gay Porn Videos{{#showPageNumber}} | Page: {{ pageNumber }}{{/showPageNumber}}",
      description:
        "Passionate gay porn videos in super HD.  Watch the hottest gay pornstars in our full-length scenes.  Updated regularly.{{#showPageNumber}} | Page: {{ pageNumber }}{{/showPageNumber}}",
    },
    "/models": {
      title:
        "{{ siteName }} : Gay Porn Models Featured on Man Royale{{#showLetter}} | By Letter: {{ letter }}{{/showLetter}} {{#showPageNumber}} | Page: {{ pageNumber }}{{/showPageNumber}}",
      description:
        "Watch exclusive gay movies in HD!{{#showLetter}} | By Letter: {{ letter }}{{/showLetter}} {{#showPageNumber}} | Page: {{ pageNumber }}{{/showPageNumber}}",
    },
  },
  "menpov.com": {
    "/": {
      title:
        "{{ siteName }} Official Site – Gay POV HD Videos{{#showPageNumber}} | Page: {{ pageNumber }}{{/showPageNumber}}",
      description:
        "The world's best gay hd pov porn videos!  Full Length Scenes Available for Download.  Updated regularly.{{#showPageNumber}} | Page: {{ pageNumber }}{{/showPageNumber}}",
    },
    "/models": {
      title:
        "{{ siteName }} : Gay Porn Models Featured on {{ siteName }}{{#showLetter}} | By Letter: {{ letter }}{{/showLetter}} {{#showPageNumber}} | Page: {{ pageNumber }}{{/showPageNumber}}",
      description:
        "Watch exclusive {{ siteName }} gay movies in HD!{{#showLetter}} | By Letter: {{ letter }}{{/showLetter}} {{#showPageNumber}} | Page: {{ pageNumber }}{{/showPageNumber}}",
    },
  },
  "mom4k.com": {
    "/": {
      title:
        "{{ siteName }} Official Site – Interracial HD MILF Videos{{#showPageNumber}} | Page: {{ pageNumber }}{{/showPageNumber}}",
      description:
        "MOM4K, the official {{ siteName }} website, features moms taking on BBC big black cocks in super high resolution. Watch our MILFs enjoy the biggest black cocks in the business. Interracial Mom Porn. {{#showPageNumber}} | Page: {{ pageNumber }}{{/showPageNumber}}",
    },
    "/login": {
      title: "{{ siteName }} Login Page to Our Member's Area",
      description:
        " Login to {{ siteName }} here to gain access to our Member's Area.",
    },
    "/models": {
      title: "Check out all of our models on {{ siteName }}!",
      description:
        "Find your favorite {{ siteName }} models from the official site in 4K HD. Organized and sorted however you like it!",
    },
    "/series": {
      title: "{{ siteName }} - Check out all of our Series",
      description: "Browse all of our {{ siteName }} Series.",
    },
    "/series/*": {
      title: "Watch {{sponsorName}} videos on {{ siteName }}!",
      description:
        "Browse all of our full length {{sponsorName}} videos on {{ siteName }} in 4K HD.",
    },
  },
  "momcum.com": {
    "/": {
      title:
        "{{ siteName }} Official Site – MILF Orgasm Videos in 4K HD{{#showPageNumber}} | Page: {{ pageNumber }}{{/showPageNumber}}",
      description:
        "Check out Mom Cum for moms having pleasure with orgasms.  Some even squirt! Download our 4K HD videos with your membership.{{#showPageNumber}} | Page: {{ pageNumber }}{{/showPageNumber}}",
    },
    "/login": {
      title: "{{ siteName }} Login Page to Our Member's Area",
      description:
        " Login to {{ siteName }} here to gain access to our Member's Area.",
    },
    "/models": {
      title: "Check out all of our models on {{ siteName }}!",
      description:
        "Find your favorite {{ siteName }} models from the official site in 4K HD. Organized and sorted however you like it!",
    },
    "/series": {
      title: "{{ siteName }} - Check out all of our Series",
      description: "Browse all of our {{ siteName }} Series.",
    },
    "/series/*": {
      title: "Watch {{sponsorName}} videos on {{ siteName }}!",
      description:
        "Browse all of our full length {{sponsorName}} videos on {{ siteName }} in 4K HD.",
    },
  },
  "myveryfirsttime.com": {
    "/": {
      title:
        "{{ siteName }} Official Site – First Time Porn in 4K HD{{#showPageNumber}} | Page: {{ pageNumber }}{{/showPageNumber}}",
      description:
        "Experience the highest quality girls doing new sexual things for the first time on My Very First Time. Watch in beautiful ULTRA DEF 4k HD as these girls try new things sexually for the very first time.{{#showPageNumber}} | Page: {{ pageNumber }}{{/showPageNumber}}",
    },
    "/login": {
      title: "{{ siteName }} Login Page to Our Member's Area",
      description:
        " Login to {{ siteName }} here to gain access to our Member's Area.",
    },
    "/models": {
      title: "Check out all of our models on {{ siteName }}!",
      description:
        "Find your favorite {{ siteName }} models from the official site in 4K HD. Organized and sorted however you like it!",
    },
    "/series": {
      title: "{{ siteName }} - Check out all of our Series",
      description: "Browse all of our {{ siteName }} Series.",
    },
    "/series/*": {
      title: "Watch {{sponsorName}} videos on {{ siteName }}!",
      description:
        "Browse all of our full length {{sponsorName}} videos on {{ siteName }} in 4K HD.",
    },
  },
  "nannyspy.com": {
    "/": {
      title:
        "{{ siteName }} Official Site – Babysitter Porn in HD 4K{{#showPageNumber}} | Page: {{ pageNumber }}{{/showPageNumber}}",
      description:
        "The official site of Nanny Spy, the best in HD babysitter porn videos!  Watch off of our 4K high definition movies shot with the latest girls caught in compromising positions while on their nanny job.{{#showPageNumber}} | Page: {{ pageNumber }}{{/showPageNumber}}",
    },
    "/login": {
      title: "{{ siteName }} Login Page to Our Member's Area",
      description:
        " Login to {{ siteName }} here to gain access to our Member's Area.",
    },
    "/models": {
      title: "Check out all of our models on {{ siteName }}!",
      description:
        "Find your favorite {{ siteName }} models from the official site in 4K HD. Organized and sorted however you like it!",
    },
    "/series": {
      title: "{{ siteName }} - Check out all of our Series",
      description: "Browse all of our {{ siteName }} Series.",
    },
    "/series/*": {
      title: "Watch {{sponsorName}} videos on {{ siteName }}!",
      description:
        "Browse all of our full length {{sponsorName}} videos on {{ siteName }} in 4K HD.",
    },
  },
  "officecock.com": {
    "/": {
      title:
        "{{ siteName }} Official Site – Gay Corporate Sex Porn{{#showPageNumber}} | Page: {{ pageNumber }}{{/showPageNumber}}",
      description:
        "Guys getting fucked in the office!  Full Length Scenes Available for Download.  Updated regularly.{{#showPageNumber}} | Page: {{ pageNumber }}{{/showPageNumber}}",
    },
    "/models": {
      title:
        "{{ siteName }} : Gay Porn Models Featured on {{ siteName }}{{#showLetter}} | By Letter: {{ letter }}{{/showLetter}} {{#showPageNumber}} | Page: {{ pageNumber }}{{/showPageNumber}}",
      description:
        "Watch exclusive {{ siteName }} gay movies in HD!{{#showLetter}} | By Letter: {{ letter }}{{/showLetter}} {{#showPageNumber}} | Page: {{ pageNumber }}{{/showPageNumber}}",
    },
  },
  "outhim.com": {
    "/": {
      title:
        "{{ siteName }} Official Site – Guys Outed Through Porn{{#showPageNumber}} | Page: {{ pageNumber }}{{/showPageNumber}}",
      description:
        "Watch these closeted straight guys be exposed!  Full Length Scenes Available for Download.  Updated regularly.{{#showPageNumber}} | Page: {{ pageNumber }}{{/showPageNumber}}",
    },
    "/models": {
      title:
        "{{ siteName }} : Gay Porn Models Featured on {{ siteName }}{{#showLetter}} | By Letter: {{ letter }}{{/showLetter}} {{#showPageNumber}} | Page: {{ pageNumber }}{{/showPageNumber}}",
      description:
        "Watch exclusive {{ siteName }} gay movies in HD!{{#showLetter}} | By Letter: {{ letter }}{{/showLetter}} {{#showPageNumber}} | Page: {{ pageNumber }}{{/showPageNumber}}",
    },
  },
  "passion-hd.com": {
    "/top-rated": {
      title:
        "Top Rated Passion HD Videos – Best Sensual Hardcore Scenes in 1080p",
      description:
        "The highest-rated sensual hardcore scenes on Passion HD, ranked by member score. Browse the best Passion HD videos in Full HD 1080p, updated as new ratings come in.",
      h1: "Top Rated Passion HD Videos",
    },
    "/": {
      title:
        "Passion-HD Official Site – Sensual Hardcore Porn in 1080p{{#showPageNumber}} | Page: {{ pageNumber }}{{/showPageNumber}}",
      description:
        "The official Passion-HD site: 1,100+ sensual, story-driven hardcore scenes in Full HD 1080p with 400+ models. New videos every week. Watch the latest now.{{#showPageNumber}} | Page: {{ pageNumber }}{{/showPageNumber}}",
      h1: "Passion-HD Official Site – Sensual Hardcore Porn Videos in Full 1080p HD",
      intro:
        "Passion HD is the home of sensual hardcore porn, filmed in crisp Full 1080p HD with real chemistry and intimate, story-driven sex. Members get unlimited streaming and downloads of the full archive, new releases added regularly. Join Passion HD today and start watching instantly.",
    },
    "/login": {
      title: "{{ siteName }} Login Page to Our Member's Area",
      description:
        " Login to {{ siteName }} here to gain access to our Member's Area.",
    },
    "/models": {
      title:
        "Passion HD Models – Pornstars in Sensual Hardcore Scenes, 1080p HD",
      description:
        "Browse every Passion HD model: pornstars filmed in sensual hardcore scenes in full 1080p HD. See each model's scenes, ranked by member rating.",
      h1: "Passion HD Models - Pornstars in Sensual Hardcore Scenes",
      intro:
        "{count} models and counting, every one filmed in full 1080p HD with free scene previews on each profile.",
      outro:
        "Passion HD is built around chemistry. Every model here was filmed in slow, sensual hardcore scenes where the focus is on real connection, not just the finish. Browse the full list to find rising stars alongside the biggest names in the business, each with a profile, every scene she has shot for Passion HD, and a free preview of each one. Models are ranked by member rating, so the most loved performers are always first. Looking for a specific style? Browse by [blowjob], [creampie], [facial], or [romantic](sensual), or check the [newest videos](/) to see who just joined.",
    },
    "/series": {
      title: "{{ siteName }} - Check out all of our Series",
      description: "Browse all of our {{ siteName }} Series.",
    },
    "/series/*": {
      title: "Watch {{sponsorName}} videos on {{ siteName }}!",
      description:
        "Browse all of our full length {{sponsorName}} videos on {{ siteName }} in 4K HD.",
    },
  },
  "pornplus.com": {
    "/top-rated": {
      title: "Top Rated PornPlus Videos – Best Scenes Across 70 Series in 4K",
      description:
        "The highest-rated scenes across all 70 PornPlus series, ranked by member score. Browse the best PornPlus videos in Full HD and 4K, updated as new ratings come in.",
      h1: "Top Rated PornPlus Videos",
    },
    "/": {
      title:
        "PornPlus Official Site – 70 Porn Series, One 4K Membership{{#showPageNumber}} | Page: {{ pageNumber }}{{/showPageNumber}}",
      description:
        "PornPlus: 70 porn series from the PornPros network in one membership. Thousands of hardcore scenes in Full HD and 4K, new videos daily. Join once, watch it all.{{#showPageNumber}} | Page: {{ pageNumber }}{{/showPageNumber}}",
      h1: "PornPlus - 70 Series in One 4K Porn Membership",
      intro:
        "PornPlus puts 70 series in one 4K porn membership, so a single login unlocks creampie, anal, amateur, MILF, petite, VR and more from across the PornPros network. New scenes are added regularly. Why pay for one site when you can have them all? Join PornPlus today.",
    },
    "/login": {
      title: "Porn+ Login Page to Our Member's Area",
      description: " Login to Porn+ here to gain access to our Member's Area.",
    },
    "/models": {
      title: "PornPlus Models – Every Pornstar on the PornPros Network in 4K",
      description:
        "Browse every PornPlus model: every pornstar from every PornPros network site in one place, in 4K. See each model's scenes, ranked by member rating.",
      h1: "PornPlus Models - Every Pornstar Across the PornPros Network",
      intro:
        "{count} models and counting across every PornPros network site, all in one membership, with free scene previews on each profile.",
      outro:
        "PornPlus is every PornPros network site in one place, which means this is the biggest model list in the network. Every performer from Passion HD, Tiny4K, Cum4K, Exotic4K, Lubed, Holed and the rest is here, with a profile that gathers every scene she has filmed across all of them. Open any model to see her full scene list, which sites she has appeared on, and a free preview of each scene. Models are ranked by member rating across the whole network. Browse by [anal], [creampie], [facial], [petite], or [MILF], or see the [newest videos](/) to find out who just joined.",
    },
    "/series": {
      title: "Porn+ Check out all of our Series on Porn Plus!",
      description:
        "Browse all of our Porn+ Series on Porn Plus. Multiple updates per day, thousands of series!",
    },
    "/series/*": {
      title: "Porn+ Watch {{sponsorName}} videos on Porn Plus!",
      description:
        "Browse all of our {{sponsorName}} videos on Porn Plus. Multiple updates per day, thousands of series!",
    },
  },
  "pornpros.com": {
    "/top-rated": {
      title: "Top Rated PornPros Videos – Best Hardcore Scenes in Full HD",
      description:
        "The highest-rated hardcore scenes on PornPros, ranked by member score. Browse the best PornPros videos in Full HD, updated as new ratings come in.",
      h1: "Top Rated PornPros Videos",
    },
    "/": {
      title:
        "PornPros Official Site – HD Porn from Every Network Site{{#showPageNumber}} | Page: {{ pageNumber }}{{/showPageNumber}}",
      description:
        "PornPros: thousands of exclusive hardcore porn videos from the PornPros network sites in Full HD and 4K, updated daily. Browse scenes, models and categories.{{#showPageNumber}} | Page: {{ pageNumber }}{{/showPageNumber}}",
      h1: "PornPros - Full HD Porn Videos from Every PornPros Network Site",
      intro:
        "PornPros brings together full HD porn videos from every PornPros network site, from hardcore and amateur to MILF, petite and virtual reality. Members get unlimited streaming and downloads, new releases added regularly. Join PornPros and get the whole network with one membership.",
    },
    "/models": {
      title:
        "PornPros Models – Every Pornstar on the PornPros Network in Full HD",
      description:
        "Browse every PornPros model: pornstars from every PornPros network site, filmed in Full HD. See each model's scenes, ranked by member rating.",
      h1: "PornPros Models - Every Pornstar on the Network",
      intro:
        "{count} models and counting from across the PornPros network, filmed in Full HD, with free scene previews on each profile.",
      outro:
        "PornPros is the original network site, and this list covers every model who has filmed for a PornPros studio. From first-timers to the biggest pornstars in the business, each profile gathers her full scene list, the studios she has worked with, and a free preview of each scene. Models are ranked by member rating, so the performers members keep watching are always first. Browse by [anal], [creampie], [facial], [teen], or [MILF], or check the [newest videos](/) to see who was just added.",
    },
    "/series": {
      title:
        "{{ siteName }} : Check out all of our HD Porn Sites {{#showPageNumber}} | Page: {{ pageNumber }}{{/showPageNumber}}",
      description:
        "Check out all of our sites included with {{{ siteName }}} {{#showPageNumber}} | Page: {{ pageNumber }}{{/showPageNumber}}",
    },
    "/series/*": {
      title:
        "{{{ sponsorName }}} Videos. {{{ sponsorName }}} is created by the Porn Pros! {{#showPageNumber}} | Page: {{ pageNumber }}{{/showPageNumber}}",
      description:
        "Download all the {{{ sponsorName }}} videos in HD directly from PornPros. We have the best quality available videos available, including in HD 1080p and 4k! {{{ sponsorName }}} is part of the Porn Pros network of sites. You can ony get that quality from us!",
    },
    "/sites": {
      title:
        "{{ siteName }} : Check out all of our HD Porn Sites {{#showPageNumber}} | Page: {{ pageNumber }}{{/showPageNumber}}",
      description:
        "Check out all of our sites included with {{{ siteName }}} {{#showPageNumber}} | Page: {{ pageNumber }}{{/showPageNumber}}",
    },
    "/sites/*": {
      title:
        "{{{ sponsorName }}} Videos. {{{ sponsorName }}} is created by the Porn Pros! {{#showPageNumber}} | Page: {{ pageNumber }}{{/showPageNumber}}",
      description:
        "Download all the {{{ sponsorName }}} videos in HD directly from PornPros. We have the best quality available videos available, including in HD 1080p and 4k! {{{ sponsorName }}} is part of the Porn Pros network of sites. You can ony get that quality from us!",
    },
  },
  "pornprosnetwork.com": {
    "/": {
      title:
        "{{ siteName }} Official Site – HD Hardcore Porn Videos{{#showPageNumber}} | Page: {{ pageNumber }}{{/showPageNumber}}",
      description:
        "Watch the best HD exclusive movies and videos on Porn Pros Network. All the hottest new Pornstar and amateur girls in High Definition updated daily.{{#showPageNumber}} | Page: {{ pageNumber }}{{/showPageNumber}}",
    },
    "/models": {
      title:
        "{{ siteName }} : Hot Pornstars Featured on Porn Pros Network {{#showLetter}} | By Letter: {{ letter }}{{/showLetter}} {{#showPageNumber}} | Page: {{ pageNumber }}{{/showPageNumber}}",
      description:
        "List of all hot hardcore Pornstars featured Porn Pros Network {{#showLetter}} | By Letter: {{ letter }}{{/showLetter}} {{#showPageNumber}} | Page: {{ pageNumber }}{{/showPageNumber}}",
    },
    "/series": {
      title:
        "{{ siteName }} : Check out all of our HD Porn Sites {{#showPageNumber}} | Page: {{ pageNumber }}{{/showPageNumber}}",
      description:
        "Check out all of our sites included with {{{ siteName }}} {{#showPageNumber}} | Page: {{ pageNumber }}{{/showPageNumber}}",
    },
    "/series/*": {
      title:
        "{{{ sponsorName }}} Videos. {{{ sponsorName }}} is created by the Porn Pros Network! {{#showPageNumber}} | Page: {{ pageNumber }}{{/showPageNumber}}",
      description:
        "Download all the {{{ sponsorName }}} videos in HD directly from PornPros. We have the best quality available videos available, including in HD 1080p and 4k! {{{ sponsorName }}} is part of the Porn Pros network of sites. You can ony get that quality from us!",
    },
  },
  "povd.com": {
    "/": {
      title:
        "{{ siteName }} Official Site – HD POV Porn Videos{{#showPageNumber}} | Page: {{ pageNumber }}{{/showPageNumber}}",
      description:
        "Experience your erotic point of view fantasies with the hottest pornstars in Full HD High Definition 1080p porn videos. Updated Daily.{{#showPageNumber}} | Page: {{ pageNumber }}{{/showPageNumber}}",
    },
    "/login": {
      title: "{{ siteName }} Login Page to Our Member's Area",
      description:
        " Login to {{ siteName }} here to gain access to our Member's Area.",
    },
    "/models": {
      title:
        "Point of View Girls - {{ siteName }} {{#showLetter}} | By Letter: {{ letter }}{{/showLetter}} {{#showPageNumber}}| Page: {{ pageNumber }}{{/showPageNumber}}",
      description:
        "Check out all of the POV girls who appear in the videos you will find when paying for access to our point of view members area {{#showLetter}} | By Letter: {{ letter }}{{/showLetter}} {{#showPageNumber}}| Page: {{ pageNumber }}{{/showPageNumber}}",
    },
  },
  "puremature.com": {
    "/top-rated": {
      title: "Top Rated PureMature Videos – Best MILF Scenes in Full HD",
      description:
        "The highest-rated MILF scenes on PureMature, ranked by member score. Browse the best PureMature videos in Full HD, updated as new ratings come in.",
      h1: "Top Rated PureMature Videos",
    },
    "/": {
      title:
        "PureMature Official Site – MILF and Mature Porn in Full HD{{#showPageNumber}} | Page: {{ pageNumber }}{{/showPageNumber}}",
      description:
        "PureMature: gorgeous MILFs and mature women in hardcore sex scenes filmed in Full HD. New MILF videos every week. Watch the latest PureMature scenes now.{{#showPageNumber}} | Page: {{ pageNumber }}{{/showPageNumber}}",
      h1: "PureMature - MILF and Mature Hardcore Porn Videos in Full HD",
      intro:
        "PureMature features MILF and mature hardcore porn videos in Full HD, starring confident, experienced women in sensual, high-end scenes. Members get the complete archive, new scenes added regularly, and unlimited streaming and downloads. Join PureMature today for the best mature porn online.",
    },
    "/login": {
      title: "{{ siteName }} Login Page to Our Member's Area",
      description:
        " Login to {{ siteName }} here to gain access to our Member's Area.",
    },
    "/models": {
      title: "PureMature Models – All MILF and Mature Pornstars in Full HD",
      description:
        "Browse every PureMature model: MILF and mature pornstars filmed in Full HD. See each model's scenes, ranked by member rating.",
      h1: "PureMature Models - MILF and Mature Pornstars in Full HD",
      intro:
        "{count} models and counting, every one filmed in Full HD with free scene previews on each profile.",
      outro:
        "PureMature is MILF and mature porn done with taste. Every model on this list is a grown woman who knows exactly what she wants, filmed in Full HD in scenes that take their time. Open any profile to see all of her PureMature scenes and a free preview of each one. Models are ranked by member rating, so the women members come back for are always first. Browse by [MILF], [mature], [big tits], or [creampie], or see the [newest videos](/) to find out who just joined.",
    },
    "/series": {
      title: "{{ siteName }} - Check out all of our Series",
      description: "Browse all of our {{ siteName }} Series.",
    },
    "/series/*": {
      title: "Watch {{sponsorName}} videos on {{ siteName }}!",
      description:
        "Browse all of our full length {{sponsorName}} videos on {{ siteName }} in 4K HD.",
    },
  },
  "showerbait.com": {
    "/": {
      title:
        "{{ siteName }} Official Site – Gay Shower Sex Videos{{#showPageNumber}} | Page: {{ pageNumber }}{{/showPageNumber}}",
      description:
        "See 4k HD gay porn shower sex videos!  Full Length Scenes Available for Download.  Updated regularly.{{#showPageNumber}} | Page: {{ pageNumber }}{{/showPageNumber}}",
    },
    "/models": {
      title:
        "{{ siteName }} : Gay Porn Models Featured on {{ siteName }}{{#showLetter}} | By Letter: {{ letter }}{{/showLetter}} {{#showPageNumber}} | Page: {{ pageNumber }}{{/showPageNumber}}",
      description:
        "Watch exclusive {{ siteName }} gay movies in HD!{{#showLetter}} | By Letter: {{ letter }}{{/showLetter}} {{#showPageNumber}} | Page: {{ pageNumber }}{{/showPageNumber}}",
    },
  },
  "spyfam.com": {
    "/top-rated": {
      title: "Top Rated SpyFam Videos – Best Step Family Scenes in 4K",
      description:
        "The highest-rated step family scenes on SpyFam, ranked by member score. Browse the best SpyFam videos in 4K, updated as new ratings come in.",
      h1: "Top Rated SpyFam Videos",
    },
    "/": {
      title:
        "SpyFam Official Site – Step Family Fantasy Porn in 4K{{#showPageNumber}} | Page: {{ pageNumber }}{{/showPageNumber}}",
      description:
        "SpyFam: step family taboo fantasies caught on hidden cameras, filmed in 4K. Stepsisters, stepmoms and stepbrothers in new scenes every week. Watch now.{{#showPageNumber}} | Page: {{ pageNumber }}{{/showPageNumber}}",
      h1: "SpyFam - Step Family Fantasy Porn Videos in 4K",
      intro:
        "SpyFam is the home of step family fantasy porn videos in 4K, with story-driven roleplay starring new porn girls and industry veterans. Members stream and download the full archive in 4K, get new scenes added regularly. Join SpyFam and see what happens when nobody's watching.",
    },
    "/login": {
      title: "{{ siteName }} Login Page to Our Member's Area",
      description:
        " Login to {{ siteName }} here to gain access to our Member's Area.",
    },
    "/models": {
      title: "SpyFam Models – All Step Family Fantasy Pornstars in 4K",
      description:
        "Browse every SpyFam model: step family fantasy pornstars filmed in 4K. See each model's scenes, ranked by member rating.",
      h1: "SpyFam Models - Step Family Fantasy Pornstars in 4K",
      intro:
        "{count} models and counting, every one filmed in 4K with free scene previews on each profile.",
      outro:
        "SpyFam is step family fantasy filmed in 4K, where getting caught is half the point. Every model on this list has played a step sister, step mom or step daughter in at least one SpyFam scene. Open any profile to see her full scene list and a free preview of each one. Models are ranked by member rating, so the performers members love most are always at the top. Browse by [step sister](stepsister), [step mom](stepmom), [caught], or [creampie], or check the [newest videos](/) to see who was just added.",
    },
    "/series": {
      title: "{{ siteName }} - Check out all of our Series",
      description: "Browse all of our {{ siteName }} Series.",
    },
    "/series/*": {
      title: "Watch {{sponsorName}} videos on {{ siteName }}!",
      description:
        "Browse all of our full length {{sponsorName}} videos on {{ siteName }} in 4K HD.",
    },
  },
  "strippers4k.com": {
    "/top-rated": {
      title:
        "Top Rated Strippers4K Videos – Best Stripper Scenes in Ultra HD 4K",
      description:
        "The highest-rated stripper scenes on Strippers4K, ranked by member score. Browse the best Strippers4K videos in Ultra HD 4K, updated as new ratings come in.",
      h1: "Top Rated Strippers4K Videos",
    },
    "/": {
      title:
        "Strippers4K Official Site – Stripper Porn in Ultra HD 4K{{#showPageNumber}} | Page: {{ pageNumber }}{{/showPageNumber}}",
      description:
        "Strippers4K: strippers, lap dances and private shows that go all the way, filmed in Ultra HD 4K. New stripper videos every week. Watch the latest scenes.{{#showPageNumber}} | Page: {{ pageNumber }}{{/showPageNumber}}",
      h1: "Strippers4K - Stripper and Lap Dance Porn Videos in Ultra HD 4K",
      intro:
        "Strippers4K brings the strip club home with stripper and lap dance porn videos in Ultra HD 4K, where private dances turn into hardcore scenes. Members unlock the full library, new scenes added regularly, and unlimited streaming and downloads. Skip the cover charge and join Strippers4K today.",
    },
    "/login": {
      title: "{{ siteName }} Login Page to Our Member's Area",
      description:
        " Login to {{ siteName }} here to gain access to our Member's Area.",
    },
    "/models": {
      title:
        "Strippers4K Models – Stripper and Lap Dance Pornstars in Ultra HD 4K",
      description:
        "Browse every Strippers4K model: stripper and lap dance pornstars filmed in Ultra HD 4K. See each model's scenes, ranked by member rating.",
      h1: "Strippers4K Models - Stripper and Lap Dance Pornstars",
      intro:
        "{count} models and counting, every one filmed in Ultra HD 4K with free scene previews on each profile.",
      outro:
        "Strippers4K starts with a lap dance and never stops there. Every model on this list has stripped on camera in Ultra HD 4K, and the dance is only the beginning. Open any profile to see all of her Strippers4K scenes and a free preview of each one. Models are ranked by member rating, so the dancers members rate highest are always first. Browse by [stripper], [lap dance], [big ass], or [creampie], or see the [newest videos](/) to find out who just joined.",
    },
    "/series": {
      title: "{{ siteName }} - Check out all of our Series",
      description: "Browse all of our {{ siteName }} Series.",
    },
    "/series/*": {
      title: "Watch {{sponsorName}} videos on {{ siteName }}!",
      description:
        "Browse all of our full length {{sponsorName}} videos on {{ siteName }} in 4K HD.",
    },
  },
  "thickandbig.com": {
    "/": {
      title:
        "{{ siteName }} Official Site – Gay Big Cock HD Videos{{#showPageNumber}} | Page: {{ pageNumber }}{{/showPageNumber}}",
      description:
        "See these gay guys with the biggest dicks!  Full Length Scenes Available for Download.  Updated regularly.{{#showPageNumber}} | Page: {{ pageNumber }}{{/showPageNumber}}",
    },
    "/models": {
      title:
        "{{ siteName }} : Gay Porn Models Featured on {{ siteName }}{{#showLetter}} | By Letter: {{ letter }}{{/showLetter}} {{#showPageNumber}} | Page: {{ pageNumber }}{{/showPageNumber}}",
      description:
        "Watch exclusive {{ siteName }} gay movies in HD!{{#showLetter}} | By Letter: {{ letter }}{{/showLetter}} {{#showPageNumber}} | Page: {{ pageNumber }}{{/showPageNumber}}",
    },
  },
  "tiny4k.com": {
    "/top-rated": {
      title: "Top Rated Tiny4K Videos – Best Petite Girl Scenes in Ultra HD 4K",
      description:
        "The highest-rated petite girl scenes on Tiny4K, ranked by member score. Browse the best Tiny4K videos in Ultra HD 4K, updated as new ratings come in.",
      h1: "Top Rated Tiny4K Videos",
    },
    "/": {
      title:
        "Tiny4K Official Site – Petite Hardcore Porn in Ultra HD 4K{{#showPageNumber}} | Page: {{ pageNumber }}{{/showPageNumber}}",
      description:
        "Tiny4K: petite, tiny girls in hardcore sex scenes filmed in Ultra HD 4K. Small bodies, big close-ups, new videos every week. Watch the latest Tiny4K scenes.{{#showPageNumber}} | Page: {{ pageNumber }}{{/showPageNumber}}",
      h1: "Tiny4K - Petite Girls in Hardcore Porn Videos, Ultra HD 4K",
      intro:
        "Tiny4K features petite adult models, all 18 and older, in hardcore porn videos filmed full length in Ultra HD 4K. Members get the complete archive, new scenes added regularly, and unlimited 4K streaming and downloads. Join Tiny4K today for petite porn in stunning 4K.",
    },
    "/login": {
      title: "{{ siteName }} Login Page to Our Member's Area",
      description:
        " Login to {{ siteName }} here to gain access to our Member's Area.",
    },
    "/models": {
      title: "Tiny4K Models – All Petite Pornstars Filmed in Ultra HD 4K",
      description:
        "Browse every Tiny4K model: petite pornstars filmed in Ultra HD 4K. See each model's scenes, ranked by member rating.",
      h1: "Tiny4K Models - Petite Pornstars in Ultra HD 4K",
      intro:
        "{count} models and counting, every one filmed in Ultra HD 4K with free scene previews on each profile.",
      outro:
        "Tiny4K is petite girls and big cameras. Every model on this list is small, and every scene is filmed in Ultra HD 4K so you see all of her. From first-timers to the most searched petite pornstars in the business, each profile has her full Tiny4K scene list and a free preview of each one. Models are ranked by member rating, so the girls members love most are always at the top. Browse by [petite], [teen], [small tits], or [creampie], or check the [newest videos](/) to see who was just added.",
    },
    "/series": {
      title: "{{ siteName }} - Check out all of our Series",
      description: "Browse all of our {{ siteName }} Series.",
    },
    "/series/*": {
      title: "Watch {{sponsorName}} videos on {{ siteName }}!",
      description:
        "Browse all of our full length {{sponsorName}} videos on {{ siteName }} in 4K HD.",
    },
  },
  "wetvr.com": {
    "/top-rated": {
      title: "Top Rated WetVR Videos – Best Virtual Reality Scenes in 4K",
      description:
        "The highest-rated virtual reality scenes on WetVR, ranked by member score. Browse the best WetVR videos in 4K VR, updated as new ratings come in.",
      h1: "Top Rated WetVR Videos",
    },
    "/": {
      title:
        "WetVR Official Site – Immersive VR Porn Videos in 4K{{#showPageNumber}} | Page: {{ pageNumber }}{{/showPageNumber}}",
      description:
        "WetVR: immersive 4K VR porn for Quest, PSVR and every major headset. POV scenes with top models, new VR videos every week. Watch the latest WetVR scenes.{{#showPageNumber}} | Page: {{ pageNumber }}{{/showPageNumber}}",
      h1: "WetVR - Immersive Virtual Reality Porn Videos in 4K",
      intro:
        "WetVR delivers immersive virtual reality porn videos in 4K, filmed for popular VR headsets with wide 180-degree views and lifelike depth. Members get the full library, new VR scenes added regularly, and unlimited streaming and downloads. Grab your headset and join WetVR today.",
    },
    "/login": {
      title: "{{ siteName }} Login Page to Our Member's Area",
      description:
        " Login to {{ siteName }} here to gain access to our Member's Area.",
    },
    "/models": {
      title: "WetVR Models – All Virtual Reality Pornstars in 4K and 8K VR",
      description:
        "Browse every WetVR model: virtual reality pornstars filmed in 4K and 8K VR. See each model's scenes, ranked by member rating.",
      h1: "WetVR Models - Virtual Reality Pornstars in 4K and 8K",
      intro:
        "{count} models and counting, every one filmed in 4K and 8K virtual reality with free previews on each profile.",
      outro:
        "WetVR puts you in the room. Every model on this list has filmed at least one virtual reality scene in 4K or 8K, shot in first person so she is looking right at you. Open any profile to see all of her WetVR scenes, which headsets each one supports, and a free preview of each. Models are ranked by member rating, so the performers members rate highest are always first. Browse by [VR], [POV], [creampie], or [petite], or see the [newest videos](/) to find out who just joined.",
    },
  },
}

// The template for `path` on `host`, or null. An exact path wins over a
// wildcard; wildcards match any path that starts with their prefix.
export const sitePageTemplate = (host, path) => {
  const templates =
    SITE_PAGE_SEO[(host ?? "").toLowerCase().replace(/^www\./, "")]
  if (!templates) return null
  if (templates[path]) return templates[path]

  const wildcard = Object.keys(templates).find(
    (key) => key.endsWith("*") && path.startsWith(key.slice(0, -1)),
  )
  return wildcard ? templates[wildcard] : null
}

// The visible <h1> for `path` on `host`, or null when the entry has none.
export const sitePageH1 = (host, path) =>
  sitePageTemplate(host, path)?.h1 || null

// The paragraph shown under the <h1> for `path` on `host`, or null when the
// entry has none.
export const sitePageIntro = (host, path) =>
  sitePageTemplate(host, path)?.intro || null

// The paragraph shown under the page's list for `path` on `host`, or null when
// the entry has none. Its links are still in `[label](target)` form.
export const sitePageOutro = (host, path) =>
  sitePageTemplate(host, path)?.outro || null

// Splits copy with inline links into the pieces to render: `{ text }` for
// plain text, `{ text, to }` for a link. `[label](/path)` links to that path.
// `[label](slug)` and a bare `[label]` (slugged from the label, so
// "[big tits]" is "big-tits") link to the tag page /tags/{slug}, but only when
// `tagSlugs` has that tag; otherwise the label stays plain text.
export const linkedCopySegments = (text, tagSlugs = []) => {
  const tags = new Set(tagSlugs)
  const segments = []
  const push = (segment) => {
    const last = segments.at(-1)
    if (!segment.to && last && !last.to) last.text += segment.text
    else segments.push(segment)
  }

  let rest = text ?? ""
  const link = /\[([^\]]+)\](?:\(([^)\s]+)\))?/
  for (let match = rest.match(link); match; match = rest.match(link)) {
    if (match.index > 0) push({ text: rest.slice(0, match.index) })

    const [whole, label, target] = match
    const slug = target ?? label.toLowerCase().replace(/\s+/g, "-")
    if (slug.startsWith("/")) push({ text: label, to: slug })
    else if (tags.has(slug)) push({ text: label, to: `/tags/${slug}` })
    else push({ text: label })

    rest = rest.slice(match.index + whole.length)
  }
  if (rest) push({ text: rest })

  return segments
}
